import { API_CALLS } from "../../../../../../API/api_calls";
import { API_PATHS } from "../../../../../../API/api_paths";
import { ArticleProps } from "../../../../../../redux/slices/article/Article";
import { AudioBackground } from "../../../../../Common";
import { useFindContent } from "../../../useFindContent";
import { ContentProps } from "../../Content";

const ArticleAudioBackground = ({ id }: ContentProps.CommonProps) => {
  const { content_id, post_id, content_data } = useFindContent(
    id
  ) as ArticleProps.WithAudioContent;
  const {
    image_id,
    id: audioId,
    background_type,
    background_value,
    gradients,
  } = content_data;

  return (
    <AudioBackground
      gradients={gradients}
      audioBackgroundImage={{
        id: audioId,
        post_id,
        image_id,
        background_type,
        background_value,
      }}
      onDelete={() => {
        API_CALLS.ARTICLE.deleteArticleAudioImage({
          content_id,
          post_id,
        });
      }}
      onGradientClick={(gradient) => {
        API_CALLS.ARTICLE.uploadAudioBackground({
          post_id,
          content_id,
          gradient: JSON.stringify(gradient),
        });
      }}
      onImageUploaded={(e) => {
        const files = e.target.files;
        if (files?.length) {
          API_CALLS.ARTICLE.uploadAudioBackground({
            post_id,
            content_id,
            image: files[0],
          });
        }
      }}
      image={API_PATHS.postAudio.audioBackgroundImage + image_id}
    />
  );
};

export default ArticleAudioBackground;
